




















































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { ProsemirrorHelper, EditorHelper } from '@getaccept/editor-lib';
import type { DropdownInputSettings, IField, IMergeValues } from '@getaccept/editor-lib';
import type { IEditorRecipientInput } from '@lib-shared/types/editor-recipient-input';
import type { ITooltip } from '@lib-shared/types/tooltip';
import ProsemirrorViewerFormOption from './ProsemirrorViewerFormOption.vue';

@Component({
  components: {
    ProsemirrorViewerFormOption,
  },
  data: () => ({
    ProsemirrorHelper,
    EditorHelper,
  }),
})
export default class InputDropdown extends Vue {
  @Prop() checked: boolean;
  @Prop() editable: boolean;
  @Prop() fields: IField[];
  @Prop() input: IField & { inputSettings: DropdownInputSettings };
  @Prop() fieldFocused: boolean;
  @Prop() mergeValues: IMergeValues;
  @Prop() recipientInput!: IEditorRecipientInput[];
  @Prop() isPdfViewer: boolean;
  @Prop() tooltip: ITooltip;
  @Prop() hasUpdateError: boolean;
  @Prop({ default: false }) isUpdating: boolean;

  isScrolling = false;
  selectedIndex = 0;

  get isDisabled(): boolean {
    return !this.editable && !this.isPdfViewer;
  }

  @Watch('fieldFocused')
  watchFieldFocused(fieldFocused: boolean) {
    if (fieldFocused) {
      const input: HTMLInputElement = document.getElementById(this.input.id) as HTMLInputElement;
      input.focus({
        preventScroll: true,
      });
    }
  }

  @Watch('selectedIndex') async watchSelectedIndex() {
    await Vue.nextTick();
    document.querySelector('.dropdown-content .select-option-item.selected')?.scrollIntoView({
      block: 'nearest',
      behavior: 'smooth',
    });
  }

  preventOpenIfDisabled(event: MouseEvent) {
    if (!this.editable) {
      event.stopPropagation();
    }
  }

  handleKeyEnter() {
    this.selectedIndex = this.input.inputSettings.options.indexOf(this.input.value);
  }

  handleKeyUp() {
    if (this.selectedIndex === 0) {
      return;
    }
    this.selectedIndex--;
  }

  handleKeyDown() {
    if (this.selectedIndex === this.input.inputSettings.options.length - 1) {
      return;
    }
    this.selectedIndex++;
  }
}
